export default require('file-size')